/* eslint-disable promise/avoid-new  -- important to create one*/
// src/utils/async/sleepWithAbort.ts
export async function sleepWithAbort(ms: number, signal?: AbortSignal): Promise<void> {
  if ((signal?.aborted) ?? false) throw new DOMException('Aborted', 'AbortError');

  await new Promise<void>((resolve, reject) => {
    const timer = setTimeout(cleanupResolve, ms);

    function onAbort() {
      cleanup();
      reject(new DOMException('Aborted', 'AbortError'));
    }

    function cleanup() {
      clearTimeout(timer);
      signal?.removeEventListener('abort', onAbort);
    }

    function cleanupResolve() {
      cleanup();
      resolve();
    }

    if (signal !== undefined) {
      signal.addEventListener('abort', onAbort, { once: true });
    }
  });
}
